import React from "react";
import PageHeader from "../components/page-header";
import { Link } from "react-router-dom";
import SuppliersActivity from "../components/suppliers-activity";

const ApiSightseeingIntegration = () => {
  return (
    <div>
      <PageHeader page="sightseeing-api-integration" />
      <div className="container">
        <div className="text-center">
          <p>
            85+ suppliers integrated—we manage integration complexity for you. Enterprise integration options: managed service (we handle it), custom connectors (built to your spec), or API-first architecture (extend without replacement). Deep relationships with activity providers and tour operators mean ongoing support, not just one-time integration.
          </p>

          <SuppliersActivity />
        </div>
      </div>
    </div>
  );
};

export default ApiSightseeingIntegration;
